import React, { useState } from 'react';
import Slider from 'react-slick';
import styles from './ProductGallery.module.scss';
import ChevronUp from '../../assets/icons/ChevronUp.png'
import ChevronDown from '../../assets/icons/ChevronDown.png'

const ProductGallery = ({ images }) => {
    const [selectedImage, setSelectedImage] = useState(1);
    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        vertical: true,
        verticalSwiping: true,
        arrows: true,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
    };

    return (
        <div className={styles.carouselContainer}>
            <Slider {...settings} className={styles.carouselSlider}>
                {images.map((item, index) => (
                    <div key={index} className={styles.carouselItem}>
                        <img
                            src={item}
                            alt={`Item ${index}`}
                            className={`${styles.carouselImage} ${selectedImage === index ? styles.carouselSelectedImage : ''}`}
                            onClick={() => setSelectedImage(index)}

                        />
                    </div>
                ))}
            </Slider>
            <div className={styles.SelectedImageContainer}>
                <img className={styles.SelectedImageContainerImage} src={images[selectedImage]} alt='bigger view' />
            </div>
        </div>
    );
};

const NextArrow = (props) => {
    const { className, style, onClick } = props;
    return (
        <img
            src={ChevronDown}
            alt='view previous'
            className={`${className} ${styles.nextArrow}`}
            style={{ ...style }}
            onClick={onClick}
        />
    );
};

const PrevArrow = (props) => {
    const { className, style, onClick } = props;
    return (
        <img
            src={ChevronUp}
            alt='previous images'
            className={`${className} ${styles.prevArrow}`}
            style={{ ...style }}
            onClick={onClick}
        />
    );
};

export default ProductGallery;
